module.exports = __webpack_public_path__ + "img/social_email.79dc8ca4.svg";